var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "hamburger",
      class: _vm.hamburgerClass,
      attrs: { type: "button" },
      on: { click: _vm.toggleActiveState },
    },
    [
      _vm._m(0),
      _c("span", { staticClass: "u-sr-only" }, [
        _vm._v(_vm._s(_vm.buttonLabel)),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "hamburger-box" }, [
      _c("span", { staticClass: "hamburger-inner" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }